    <section class="fj-hotspot-section">
        <div class="site-container fj-hotspot-grid">
            <div class="fj-hotspot-intro">
                <div>
                    <p class="eyebrow">Inspection scope</p>
                    <h1>See the visible systems Roland reviews during a GTX home inspection.</h1>
                    <p>
                        Use the house map to move through exterior, roof, attic, HVAC, interior, electrical, and
                        plumbing checkpoints before opening the full system detail.
                    </p>
                </div>
                <aside class="fj-selected-system-brief" aria-live="polite">
                    <span>{{ selectedSystem.area }}</span>
                    <strong>{{ selectedSystem.title }}</strong>
                    <p>{{ selectedSystem.summary }}</p>
                    <small>{{ selectedSystem.items.length }} visible checks in this system</small>
                </aside>
            </div>
            <div class="fj-house-map cutaway-visual-card" aria-label="Interactive inspection system hotspots">
                <div class="cutaway-stage">
                    <svg class="cutaway-house-svg" viewBox="0 0 1100 680" preserveAspectRatio="xMidYMid meet" role="img"
                        aria-label="Flat vector house cutaway with inspection system hotspots">
                        <defs>
                            <linearGradient id="inspectionCutawayRoof" x1="0" x2="0" y1="0" y2="1">
                                <stop offset="0%" stop-color="#496676" />
                                <stop offset="100%" stop-color="#1f3a48" />
                            </linearGradient>
                            <linearGradient id="inspectionCutawayWall" x1="0" x2="1" y1="0" y2="0">
                                <stop offset="0%" stop-color="#f9fbf8" />
                                <stop offset="100%" stop-color="#edf4f1" />
                            </linearGradient>
                            <linearGradient id="inspectionCutawayInterior" x1="0" x2="0" y1="0" y2="1">
                                <stop offset="0%" stop-color="#fff9ed" />
                                <stop offset="100%" stop-color="#eff5f2" />
                            </linearGradient>
                            <filter id="inspectionCutawayShadow" x="-20%" y="-20%" width="140%" height="150%">
                                <feDropShadow dx="0" dy="18" stdDeviation="18" flood-color="#102a31" flood-opacity="0.16" />
                            </filter>
                        </defs>

                        <g filter="url(#inspectionCutawayShadow)">
                            <path d="M106 600 H1000" stroke="#8da48f" stroke-width="16" stroke-linecap="round" opacity="0.45" />
                            <path d="M150 598 C228 552 304 562 382 592" fill="none" stroke="#2f6f7a" stroke-width="8" stroke-linecap="round" opacity="0.5" />
                            <path d="M148 625 C250 595 340 607 442 632" fill="none" stroke="#90a882" stroke-width="6" stroke-linecap="round" opacity="0.72" />

                            <rect x="184" y="520" width="732" height="58" rx="6" fill="#cdd8d1" stroke="#83978f" stroke-width="4" />
                            <path d="M292 535 H544 V575 H292 Z" fill="#8c9d96" opacity="0.52" />
                            <path d="M314 548 H522 M314 562 H522" stroke="#eff6f4" stroke-width="4" opacity="0.6" />

                            <rect x="196" y="263" width="708" height="262" rx="8" fill="url(#inspectionCutawayWall)" stroke="#a8bdb6" stroke-width="4" />
                            <path d="M146 266 L550 88 L954 266 L924 298 L550 138 L176 298 Z" fill="url(#inspectionCutawayRoof)" stroke="#172d34" stroke-width="5" stroke-linejoin="round" />
                            <path d="M260 265 L550 140 L840 265 Z" fill="#f0dcc2" stroke="#d2b991" stroke-width="3" />
                            <path d="M336 247 L550 157 L764 247 M378 225 L550 151 L722 225 M420 204 L550 148 L680 204" fill="none" stroke="#8b6f4a" stroke-width="4" opacity="0.38" />
                            <rect x="760" y="146" width="54" height="92" rx="4" fill="#455e67" stroke="#172d34" stroke-width="4" />
                            <path d="M748 146 H826" stroke="#172d34" stroke-width="10" stroke-linecap="round" />

                            <path d="M220 300 H880 M220 338 H880 M220 376 H880 M220 414 H880 M220 452 H880 M220 490 H880" stroke="#d7e4df" stroke-width="3" />
                            <path d="M454 306 V506 M684 306 V506" stroke="#c4d0ca" stroke-width="5" />

                            <rect x="224" y="306" width="210" height="200" rx="6" fill="url(#inspectionCutawayInterior)" stroke="#c6d4ce" stroke-width="3" />
                            <rect x="466" y="306" width="206" height="200" rx="6" fill="#f8fbf8" stroke="#c6d4ce" stroke-width="3" />
                            <rect x="704" y="334" width="176" height="172" rx="6" fill="#edf4f1" stroke="#b5c8c4" stroke-width="3" />

                            <rect x="267" y="374" width="62" height="82" rx="5" fill="#8fb5bd" stroke="#335d67" stroke-width="4" />
                            <path d="M279 390 H317 M279 416 H317 M298 378 V452" stroke="#f4faf9" stroke-width="4" />
                            <rect x="358" y="358" width="58" height="74" rx="5" fill="#a8c7ce" stroke="#446b74" stroke-width="4" />
                            <path d="M358 382 H416 M387 358 V432" stroke="#eef5f3" stroke-width="4" />

                            <rect x="508" y="374" width="84" height="132" rx="5" fill="#806b53" stroke="#5c4b39" stroke-width="4" />
                            <circle cx="578" cy="440" r="6" fill="#d7b25f" />
                            <rect x="607" y="356" width="48" height="58" rx="5" fill="#a8c7ce" stroke="#446b74" stroke-width="4" />
                            <path d="M607 384 H655 M631 356 V414" stroke="#eef5f3" stroke-width="4" />

                            <rect x="724" y="368" width="132" height="112" rx="5" fill="#d7dde0" stroke="#6c7d82" stroke-width="4" />
                            <path d="M736 392 H844 M736 420 H844 M736 448 H844" stroke="#80949a" stroke-width="5" />
                            <path d="M846 368 V480" stroke="#eef5f3" stroke-width="4" opacity="0.52" />

                            <rect x="746" y="410" width="45" height="78" rx="18" fill="#e8eef0" stroke="#71858b" stroke-width="4" />
                            <path d="M776 410 C790 374 834 386 834 424 V468" fill="none" stroke="#476f7b" stroke-width="8" stroke-linecap="round" />
                            <path d="M588 450 C622 436 652 452 686 440" fill="none" stroke="#2f6f7a" stroke-width="7" stroke-linecap="round" opacity="0.72" />
                            <rect x="922" y="462" width="92" height="68" rx="7" fill="#d7dde0" stroke="#6c7d82" stroke-width="4" />
                            <path d="M938 480 H998 M938 500 H998 M968 462 V530" stroke="#80949a" stroke-width="5" />
                            <circle cx="968" cy="496" r="22" fill="none" stroke="#5b8792" stroke-width="5" opacity="0.76" />

                            <path d="M198 302 H172 V534" fill="none" stroke="#496676" stroke-width="8" stroke-linecap="round" />
                            <path d="M172 534 C138 548 122 566 112 596" fill="none" stroke="#2f6f7a" stroke-width="8" stroke-linecap="round" />
                            <path d="M190 254 H912" stroke="#172d34" stroke-width="5" opacity="0.2" />
                            <path d="M184 520 H916" stroke="#172d34" stroke-width="5" opacity="0.15" />
                        </g>
                    </svg>

                    <div class="cutaway-hotspots" role="group" aria-label="Inspectable house systems">
                        <button *ngFor="let system of systems; let i = index" class="cutaway-hotspot" type="button"
                            [class.is-selected]="system === selectedSystem"
                            [style.left.%]="system.mapX" [style.top.%]="system.mapY"
                            [attr.aria-pressed]="system === selectedSystem"
                            [attr.aria-label]="'Open ' + system.title + ' details'"
                            aria-controls="fieldJournalSystemModal"
                            aria-haspopup="dialog"
                            (click)="openFieldJournalSystemModal(system.title)">
                            <span class="cutaway-hotspot-index">{{ i + 1 }}</span>
                            <span class="cutaway-hotspot-label">{{ system.group }}</span>
                        </button>
                    </div>
                </div>
                <div class="fj-map-key">
                    <span>{{ selectedSystem.area }}</span>
                    <strong>{{ selectedSystem.title }}</strong>
                    <small>{{ selectedSystem.area }} / {{ selectedSystem.items.length }} visible checks</small>
                </div>
            </div>
        </div>

        <div *ngIf="isFieldJournalSystemModalOpen" class="fj-hotspot-modal-backdrop"
            (click)="closeFieldJournalSystemModal()">
            <article id="fieldJournalSystemModal" class="fj-hotspot-modal" role="dialog" aria-modal="true"
                aria-labelledby="fieldJournalSystemModalTitle"
                aria-describedby="fieldJournalSystemModalSummary"
                (click)="$event.stopPropagation()">
                <button type="button" class="fj-modal-close" aria-label="Close inspection detail modal"
                    (click)="closeFieldJournalSystemModal()">X</button>
                <header>
                    <div class="fj-modal-topbar">
                        <span class="mini-label">System {{ selectedSystemNumber }} of {{ systems.length }}</span>
                        <div class="fj-modal-pager" aria-label="Browse inspection systems">
                            <button type="button" class="ng-button ng-button-secondary"
                                [attr.aria-label]="'Previous system: ' + previousSystemLabel"
                                (click)="selectPreviousSystem()">
                                Previous
                            </button>
                            <button type="button" class="ng-button ng-button-secondary"
                                [attr.aria-label]="'Next system: ' + nextSystemLabel"
                                (click)="selectNextSystem()">
                                Next
                            </button>
                        </div>
                    </div>
                    <h2 id="fieldJournalSystemModalTitle">{{ selectedSystem.title }}</h2>
                    <p id="fieldJournalSystemModalSummary">{{ selectedSystem.summary }}</p>
                </header>
                <div class="fj-modal-body">
                    <img [src]="selectedSystem.image" [alt]="selectedSystem.title + ' checkup image'"
                        [style.object-position]="selectedSystem.imagePosition" />
                    <div class="fj-modal-copy">
                        <div class="scope-progress">
                            <span>Scope progress</span>
                            <strong>{{ selectedSystemProgress }}%</strong>
                            <div><i [style.width.%]="selectedSystemProgress"></i></div>
                        </div>
                        <dl>
                            <div>
                                <dt>Condition signal</dt>
                                <dd>{{ selectedSystem.fieldSignal }}</dd>
                            </div>
                            <div>
                                <dt>Decision lens</dt>
                                <dd>{{ selectedSystem.decisionLens }}</dd>
                            </div>
                            <div>
                                <dt>Client question</dt>
                                <dd>{{ selectedSystem.clientQuestion }}</dd>
                            </div>
                        </dl>
                        <div class="fj-checkpoint-list" aria-label="Visible checkpoints for selected system">
                            <span *ngFor="let item of selectedSystem.items; let i = index">
                                <small>{{ i + 1 }}</small>
                                {{ item }}
                            </span>
                        </div>
                    </div>
                </div>
                <footer class="fj-modal-actions">
                    <a class="ng-button ng-button-primary" routerLink="/contact">Ask about this system</a>
                </footer>
            </article>
        </div>
    </section>

    <section class="fj-accordion-scope">
        <div class="site-container">
            <div class="fj-scope-head">
                <div>
                    <p class="eyebrow">What is included</p>
                    <h2>Every inspection checkpoint stays open for a full-scope review.</h2>
                </div>
                <p>
                    Each module connects visible observations, report language, and practical homeowner context
                    so the full scope is visible in one pass.
                </p>
            </div>
            <div class="fj-scope-ledger" aria-label="Selected inspection checkup" aria-live="polite">
                <article *ngFor="let stat of scopeStats">
                    <span>{{ stat.label }}</span>
                    <strong>{{ stat.value }}</strong>
                    <p>{{ stat.description }}</p>
                </article>
                <article>
                    <span>Full scope</span>
                    <strong>All systems</strong>
                    <p>{{ systems.length }} systems / {{ totalCheckpoints }} visible checkpoints</p>
                </article>
            </div>
            <div class="fj-system-accordion">
                <details *ngFor="let system of systems">
                    <summary>
                        <span class="fj-accordion-arrow" aria-hidden="true"></span>
                        <strong>{{ system.title }}</strong>
                        <small>{{ system.area }} / {{ system.items.length }} checkpoints</small>
                    </summary>
                    <div class="fj-accordion-body">
                        <p>{{ system.summary }}</p>
                        <div class="fj-checkpoint-list">
                            <span *ngFor="let item of system.items; let i = index">
                                <small>{{ i + 1 }}</small>
                                {{ item }}
                            </span>
                        </div>
                    </div>
                </details>
            </div>
        </div>
    </section>

    <app-inspection-process-timeline></app-inspection-process-timeline>

    <section class="fj-page-cta">
        <div class="site-container fj-page-cta-grid">
            <div>
                <p class="eyebrow">Ready for a documented walk-through?</p>
                <h2>Schedule with GTX before your next inspection deadline.</h2>
            </div>
            <div class="hero-actions">
                <a class="ng-button ng-button-primary" routerLink="/contact">Schedule an inspection</a>
                <a class="ng-button ng-button-secondary" href="tel:512-848-1316">Call/Text (512) 848-1316</a>
            </div>
        </div>
    </section>
